import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  BoxStatus,
  TableData,
  TableFooter,
  TablePagination,
  TableShowPages,
  TableHeader,
  Select,
} from "codekit";
import { settingsColorStatusTransporte, columnsTransporte } from "../utils/configxx"

const generatePagination = (currentPage, lastPage) => {
  if (lastPage <= 1) return [];
  const pages = [];
  const maxVisiblePages = 5;
  if (lastPage <= maxVisiblePages) {
    for (let i = 1; i <= lastPage; i++) {
      pages.push({ label: i, isActive: i === currentPage });
    }
  } else {
    if (currentPage <= 3) {
      for (let i = 1; i <= 4; i++) {
        pages.push({ label: i, isActive: i === currentPage });
      }
      pages.push({ label: "...", isActive: false, isDisabled: true });
      pages.push({ label: lastPage, isActive: false });
    } else if (currentPage >= lastPage - 2) {
      pages.push({ label: 1, isActive: false });
      pages.push({ label: "...", isActive: false, isDisabled: true });
      for (let i = lastPage - 3; i <= lastPage; i++) {
        pages.push({ label: i, isActive: i === currentPage });
      }
    } else {
      pages.push({ label: 1, isActive: false });
      pages.push({ label: "...", isActive: false, isDisabled: true });
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pages.push({ label: i, isActive: i === currentPage });
      }
      pages.push({ label: "...", isActive: false, isDisabled: true });
      pages.push({ label: lastPage, isActive: false });
    }
  }
  return pages;
};


const tableColumnNameFormatter = (columnName) => {
  const tableColumnName = columnName.split(".");
  const name = tableColumnName.length > 1 ? tableColumnName[1] : tableColumnName[0];
  return name;
};

const generateTableColumnsMap = (columns) => {
  return columns.map((tableColumn) => ({
    id: tableColumnNameFormatter(tableColumn.NOMCOLXX),
    isShow: tableColumn.SHOWCOLX === "SI",
    isMobileShow: tableColumn.SHOWCOLX === "SI",
    orderBy: "asc",
    sorted: false,
    title: tableColumn.CAMPODES,
    canToggleShow: tableColumn.CAMPKEYX !== "SI",
    sortable: false,
  }));
};

const Creadop2 = ({ data, meta, onPageChange, onPerPageChange, onFilterChange, isLoading, isError, handleCheckedRows, checkedRows }) => {

  console.log(data);
  const currentPage = meta?.current_page || 1;
  const lastPage = meta?.last_page || 1;
  const tableColumnsMap = useMemo(() => generateTableColumnsMap(columnsTransporte), []);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");

  console.log(tableColumnsMap);
  console.log(data);

  const activeRowValidation = (row) => true;

  const handleSearchFiltersMap = useMemo(() => {
    return columnsTransporte
      .filter((column) => column.CAMPKEYX === "SI")
      .map((column) => ({
        text: column.CAMPODES,
        value: column.NOMCOLXX,
      }));
  }, []);

  useEffect(() => {
    if (handleSearchFiltersMap.length > 0 && !searchFilter) {
      setSearchFilter(handleSearchFiltersMap[0].value);
    }
  }, [handleSearchFiltersMap, searchFilter]);

  const handleOnSearchFilterChange = (selectedOption) => {
    const valueToSet = selectedOption.option.value;
    setSearchFilter(valueToSet);
    onFilterChange(valueToSet, searchInputValue);
  };

  const handleSearchInputChange = (value) => {
    setSearchInputValue(value);
    onFilterChange(searchFilter, value);
  };

  const processedData = data.map(row => {
    return {
      ...row,
      ODIIDDES: (row.ODIIDDES === "" || row.ODIIDDES === null)
        ? row.DTRCLUIN
        : row.ODIIDDES
    };
  });

  return (
    <>
      <TableHeader
        permissions={{
          consult: false,
          export: false,
          reports: false,
        }}
        selectFilter={
          <Select
            value={searchFilter}
            variant="no-border"
            onChangeValue={handleOnSearchFilterChange}
            options={handleSearchFiltersMap}
          />
        }
        search={{
          placeholder: 'Realiza una búsqueda como "10001"',
          minLengthToSearch: 3,
          onSearch: handleSearchInputChange,
        }}
      />
      <Box className="flex flex-col gap-4">
        {isLoading ? (
          <BoxStatus variant="loading" text="Cargando información..." rounded="xl" />
        ) : (data?.length === 0 || isError) ? (
          <BoxStatus variant="empty" text="No se encontraron registros" rounded="xl" />
        ) : (
          <Box spacing={4}>
            <TableData
              data={processedData}
              actions={[]}
              columns={tableColumnsMap}
              onRowClick={() => { }}
              activeRowValidation={activeRowValidation}
              isCheckedRow={true}
              handleCheckedRow={handleCheckedRows}
              checkedRows={checkedRows}
              colorColumn={settingsColorStatusTransporte}
              rowKey="DTRCDOTR"
            />

          </Box>
        )}
      </Box>
      <TableFooter>
        <TablePagination
          prevActive={currentPage > 1}
          nextActive={currentPage < lastPage}
          items={generatePagination(currentPage, lastPage)}
          onPrevClick={() => onPageChange(currentPage - 1)}
          onNextClick={() => onPageChange(currentPage + 1)}
          onItemClick={(context) => onPageChange(context.item.label)}
          trackingMeta={meta}
        />
        <TableShowPages
          pages={[5, 10, 25, 50]}
          onChangePage={onPerPageChange}
          trackingMeta={meta}
        />
      </TableFooter>
    </>
  );
};

export default Creadop2;
